// mocks/mockKnowledgeArticles.ts
import { KnowledgeArticle } from "../types/features/support/KnowledgeArticle";

export const mockKnowledgeArticles: KnowledgeArticle[] = [
  {
    id: "170",
    title: "SERVICES DISPONIBLES",
    slug: "services-disponibles",
    category: "Information Générale",
    objective:
      "Permettre à l'agent de répondre aux questions générales concernant IZI Life Pay, ses services, sa disponibilité et son support client.",
    description:
      "L'utilisateur recherche des informations générales sur la plateforme, ses fonctionnalités, ses pays couverts ou ses moyens de contact.",
    causes: [
      "Nouvel utilisateur",
      "Découverte de la plateforme",
      "Recherche d'informations",
      "Besoin d'assistance",
      "Demande commerciale",
    ],
    signs: [
      "Le client affirme : 'Quels sont les services disponibles ?'",
      "Qu'est-ce que je peux faire avec IZI Life Pay ?",
      "Quels sont les services proposés par la plateforme ?",
      "Je veux connaître tous les services IZI Life Pay.",
    ],
    agent_procedure: [
      "Étape 1 : Identifier la demande du client",
      "Étape 2 : Fournir les informations officielles",
      "Étape 3 : Vérifier si des informations complémentaires sont nécessaires",
      "Étape 4 : Orienter vers le bon service si besoin",
      "Étape 5 : Fournir les ressources utiles",
    ],
    technical_procedure: [
      "Vérifier les informations officielles à jour",
      "Vérifier les pays disponibles",
      "Vérifier les horaires de support",
      "Vérifier les canaux de communication actifs",
    ],
    errors_to_avoid: ["Ne pas donner d'informations non vérifiées", "Ne pas orienter vers le mauvais service"],
    escalation: {
      to: "Service Client / Marketing / Business Development",
      when: ["Demande complexe", "Information non disponible", "Demande commerciale"],
    },
    client_response:
      "Nous sommes heureux de vous fournir toutes les informations nécessaires concernant IZI Life Pay, ses services et les moyens de vous accompagner dans l'utilisation de notre plateforme.",
    product_doc: "Présentation IZI Life Pay, Support Client, Pays disponibles, Services, FAQ",
    responsible_department: "Service Client → Information Générale",
    keywords: ["services disponibles", "services izi", "fonctionnalites izi", "quoi faire sur izi"],
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];
